import React, { FC, useEffect, useState } from "react";
import { ApplicationFeature, FormBaseType } from "@green0meter/api-client";
import { t } from "i18next";
import { isEmpty } from "lodash";

import SupplierHubReports from "./SupplierHubReports";

import { useGetReportsMetadata } from "@api";
import { CardTable, DownloadButton } from "@components/common";
import { useUserStore } from "@store/user";
import { formatDateUtc } from "@helpers";

const columns: CardTable["columns"] = [
  {
    field: "name",
    title: t("common.fileName"),
    tableProps: {
      sx: {
        minWidth: 120,
      },
    },
  },
  {
    field: "createdAt",
    title: t("common.date"),
    tableProps: {
      width: 150,
    },
  },
  {
    field: "action",
    title: t("common.action"),
    tableProps: {
      sx: {
        width: 220,
      },
    },
  },
];

interface SupplierHubReportsContainer {
  formBaseType: FormBaseType;
}

const SupplierHubReportsContainer: FC<SupplierHubReportsContainer> = ({
  formBaseType,
}) => {
  const { user } = useUserStore();
  const { reportsMetadata, reportsMetadataEnabled, isSuccessReports } =
    useGetReportsMetadata(user, {
      formBaseType,
      relatedFeature: ApplicationFeature.PROCUREMENT_SUPPLIER,
    });

  const [rows, setRows] = useState<CardTable["rows"]>([]);

  useEffect(() => {
    if (reportsMetadata && !isEmpty(reportsMetadata)) {
      const _rows = reportsMetadata.map((report) => {
        return {
          name: report.name,
          createdAt: formatDateUtc(report.createdAt),
          action: <DownloadButton report={report} />,
        };
      });

      setRows(_rows);
    }
  }, [reportsMetadata]);

  return (
    reportsMetadataEnabled && (
      <SupplierHubReports
        columns={columns}
        rows={rows}
        isLoaded={isSuccessReports}
      />
    )
  );
};

export default SupplierHubReportsContainer;
